import DynamicTitle from "../components/DynamicTitle";

export default function JobsSettings() {
    return (
        <div className="page">
            <DynamicTitle title="Impostazioni Lavori" />
            
            <h1>Impostazioni Lavori</h1>
            
            <div className="mt-8 p-6 bg-white rounded-lg shadow-md">
                <p className="text-gray-600 text-center">
                    Questa sezione è in fase di sviluppo.
                </p>
            </div>
        </div>
    );
}
